var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.12207C0.5 0.95631 0.565848 0.797339 0.683058 0.680128C0.800268 0.562918 0.95924 0.49707 1.125 0.49707H14.8783C14.9944 0.49707 15.1082 0.529392 15.2069 0.590414C15.3056 0.651435 15.3854 0.738746 15.4373 0.842562C15.4893 0.946378 15.5112 1.0626 15.5008 1.1782C15.4904 1.2938 15.448 1.40421 15.3783 1.49707L11.9083 6.1229L15.3783 10.7496C15.448 10.8424 15.4904 10.9528 15.5008 11.0684C15.5112 11.184 15.4893 11.3003 15.4373 11.4041C15.3854 11.5079 15.3056 11.5952 15.2069 11.6562C15.1082 11.7172 14.9944 11.7496 14.8783 11.7496H1.75V15.7071C1.74999 15.8581 1.6953 16.004 1.59603 16.1178C1.49676 16.2317 1.35963 16.3057 1.21 16.3262L1.125 16.3329C0.973969 16.3329 0.828048 16.2782 0.714224 16.1789C0.600401 16.0797 0.526374 15.9425 0.505833 15.7929L0.5 15.7071V1.12207Z",
    fill: "#A1ADC4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityFlag);
export default __webpack_public_path__ + "static/media/activity_flag.e3bbbd567ddf392a51cbc286b8cfb141.svg";
export { ForwardRef as ReactComponent };